import * as signalR from "@microsoft/signalr"
import { DefaultURl } from 'src/M_Components'

class SignalRService {
  connection = null
  isStarting = false

  hubUrl = `${DefaultURl}trasnporterNotification/integrationhub`

  async start() {
    if (this.connection?.state === signalR.HubConnectionState.Connected) {
      return this.connection
    }
    
    if (this.isStarting) {
      return this.connection
    }

    this.isStarting = true

    this.connection = new signalR.HubConnectionBuilder()
      .withUrl(this.hubUrl, {
        accessTokenFactory: () => localStorage.getItem("tokenMaeil"),
        withCredentials : false
      })
      .withAutomaticReconnect()
      .configureLogging(signalR.LogLevel.Warning)
      .build()

    try {
      await this.connection.start()
      // console.log("SignalR connected")
    } catch (err) {
      console.error("SignalR error:", err)
    } finally {
      this.isStarting = false
    }

    return this.connection
  }

  async joinGroup(processKey) {
    if (!this.connection || this.connection.state !== signalR.HubConnectionState.Connected) {
      console.warn("Connection not ready")
      return
    }
    
    try {
      await this.connection.invoke("JoinProcessGroup", processKey)
      // console.log(`Joined: ${processKey}`)
    } catch (err) {
      console.error(`Failed to join ${processKey}:`, err)
    }
  }

  async leaveGroup(processKey) {
    if (!this.connection || this.connection.state !== signalR.HubConnectionState.Connected) {
      return
    }
    
    try {
      await this.connection.invoke("LeaveProcessGroup", processKey)
      // console.log(`Left: ${processKey}`)
    } catch (err) {
      console.error(`Failed to leave ${processKey}:`, err)
    }
  }

  on(event, callback) {
    this.connection?.on(event, callback)
  }

  off(event) {
    this.connection?.off(event)
  }
}

export default new SignalRService()